
/**********************************************************
 *  Imports
 **********************************************************/

 // React
import React, { Component } from "react";
import { Helmet } from "react-helmet";

// Components
import { Chart, PriceHolder } from './';

// Stores
import { ChartStore } from '../Stores';

/**********************************************************
 * 
 *  The Markets class is the parent of both prices and chart, 
 *  and is used to represent the markets page.
 * 
 **********************************************************/

class Markets extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/

    constructor(props) {

        super(props);

        this.state = { };

    }

/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render, fetch all parameters and the corresponding chart
    componentDidMount() {

        //console.log('Markets.componentDidMount()');

    }


/**********************************************************
 *  Helper Functions
 **********************************************************/

    // Returns the modified chart settings
    prepareChart() {

        // Check screen size
        var screenSize = this.getScreenSize();
    
        // Retrieve chart properties
        var chartProps = ChartStore.getChartProperties();
    
        chartProps.height = screenSize.height * 0.46; //400;

        // 83% of screen, -30px padding, 83% of div
        chartProps.width = (((screenSize.width * 0.75) - 40) - 40) * 0.83; 
        chartProps.ticks.x = Math.floor(chartProps.width / 50);
        chartProps.ticks.y = Math.floor(chartProps.height / 50);
        chartProps.candlesAppearance.number = 40;
        chartProps.volumeHeight = chartProps.height * 0.2;

        return chartProps;
    }


    // Gets the current screen size
    getScreenSize() {
        return { width: window.innerWidth, height: window.innerHeight };
    }


/**********************************************************
 *  Render
 **********************************************************/

  render() {

    //console.log('Markets.render()');

    var chartProps = this.prepareChart();

    var chart = null;

    const mobile = window.innerWidth < 1024;
                                                            
    if(!mobile) {

        chart = ( 
            <div className="panel panel-flat bg-theme-700">
            
                <div className="dashboard-chart">

                    <Chart properties={chartProps} mobile={false}/>

                </div>
            </div>
        );

    }

    return (

        <div className="page-container">

            <Helmet>
                <meta charSet="utf-8" />
                <title>Yety | Markets - Cryptocurrency Trading and Analytics Platform - Real-Time Prices and Charting from Coinbase, Poloniex, Kraken and BitTrex</title>
                <link rel="canonical" href="https://yety.io/markets" />
                <meta name="keywords" content="cryptocurrency, trading, analytics, pnl, profit, loss, holdings, assets, margin, positions, orders, kraken, poloniex, BTC, ETH, LTC, XRP, DASH, BCH EUR, USD, CAD"/>
                <meta name="description" content="Yety Markets has real-time prices from four major cryptocurrency exchanges: Coinbase, Poloniex, Kraken and BitTrex. Switch tabs and look at the latest market cap numbers for the top 100 coins.  Check out the detailed charting in one minute, one hour and one day timeframes, also with advanced trading overlays." />

                <meta property="og:url" content="https://yety.io/markets" />
                <meta property="og:title" content="Yety | Markets - Cryptocurrency Trading and Analytics Platform" />
                <meta property="fb:app_id" content="378120756002310" />
                <meta property="twitter:title" content="Yety | Markets - Cryptocurrency Trading and Analytics Platform" />
            </Helmet>

            <div className="page-content">

                <div className="content-wrapper">

                    {/*-----------  Content Area -----------*/}
                    <div className="content" style={ {paddingBottom:0 }}>

                        {/*-----------  Grid -----------*/}
                        <div className="row row-sortable ui-sortable">

                            <div className="col-lg-3 col-md-4 col-sm-12 col-xs-12">

                                <PriceHolder />

                            </div>
                            
                            <div className="col-lg-9 col-md-8" style={{padding:0}}>

                                { chart }

                            </div>

                        </div>
                        {/*-----------  /Grid -----------*/}

                    </div>
                    {/*-----------  /Content Area -----------*/}


                </div>

            </div>

        </div>
    );
    }
}

export default Markets;





// WEBPACK FOOTER //
// ./src/Views/Markets.js